module.exports = __webpack_public_path__ + "6ba0be370da58aca32cc3299adc25697.pdf";